import PropTypes from 'prop-types'
import { FormControl } from 'baseui/form-control'
import { SIZE } from 'baseui/button'
import { Editor } from '@tinymce/tinymce-react'

import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import SDLoader from '@/shared/components/SDComponentsNewDesign/SDLoader/SDLoader'

import useCommunicationBoard from './useCommunicationBoard'
import { ActionsRow, FieldsColumn, NotificationsWrapper } from './styled-components'

const EDITOR_INIT = {
  plugins: [
    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
    'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'code', 'wordcount', 'emoticons',
  ],
  toolbar:
    'undo redo | formatselect | bold italic backcolor | alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons | help | code',
  height: 240,
  menubar: false,
}

const CommunicationBoardForm = ({ sections }) => {
  const { form, result, t } = useCommunicationBoard({ sections })

  return (
    <>
      <FieldsColumn>
        <FormControl>
          <SDSelect
            label={t('communication_board.label_section')}
            optionsList={form.sectionsOptions}
            selectedValue={form.section}
            onChangeHandler={params => form.onSectionChange(params.option?.id)}
            placeholder={t('common:choose')}
            overrides={{
              Popover: {
                props: {
                  overrides: {
                    Body: {
                      style: () => ({
                        left: '1px',
                        marginTop: '.5rem',
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        zIndex: 1000,
                      }),
                    },
                  },
                },
              },
            }}
          />
        </FormControl>
      </FieldsColumn>

      <FormControl label={t('communication_board.label_content')}>
        <Editor
          apiKey={form.tinymceKey}
          value={form.content}
          onEditorChange={form.onContentChange}
          init={EDITOR_INIT}
        />
      </FormControl>

      <ActionsRow>
        <SDButton size={SIZE.compact} block={false} disabled={form.isSaving} onClick={form.onSave}>
          {form.isSaving ? t('common:saving') : t('common:save')}
        </SDButton>
        <SDLoader hidden={!form.isLoading} text={t('common:fetching_data')} />
      </ActionsRow>

      <NotificationsWrapper>
        <SDNotification
          type="negative"
          hidden={!(result.error && !result.message)}
          primaryText={String(result.error || '')}
        />
        <SDNotification
          type={result.error ? 'negative' : 'positive'}
          hidden={!result.message}
          primaryText={String(result.message || '')}
        />
      </NotificationsWrapper>
    </>
  )
}

CommunicationBoardForm.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string),
}

export default CommunicationBoardForm
